import React, { Component } from "react";
import { Popover, PopoverBody, PopoverHeader } from "reactstrap/lib";
import { Button, Modal, ModalBody } from 'reactstrap';
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import { setError, setSuccess, setLoader } from "../../../actions/action-creators";
import CONSTANTS from "../../../constants/index";
import { Icon } from "@material-ui/core";
import moment from "moment";
import PartnerMapDetail from "../dashboard/partner_map_detail";
import InputFeild from "../../global/form/input";
import JobInformation from "../project/job_information";
import { copyCodeToClipboard, groupArrayOnKey } from "../../../actions";

const PS = {
    container:       { padding: "20px 4px" },
    topBar:          { display: "flex", alignItems: "center", gap: 12, marginBottom: 18, flexWrap: "wrap" },
    switcher:        { display: "flex", border: "1px solid #e0e0e0", borderRadius: 8, overflow: "hidden", flexShrink: 0 },
    switchBtn:       { padding: "8px 20px", background: "#fff", border: "none", fontSize: 13, fontWeight: 500, color: "#555", cursor: "pointer", borderRight: "1px solid #e0e0e0" },
    switchBtnLast:   { padding: "8px 20px", background: "#fff", border: "none", fontSize: 13, fontWeight: 500, color: "#555", cursor: "pointer" },
    switchBtnActive: { background: "#c0392b", color: "#fff" },
    searchInput:     { border: "1px solid #e0e0e0", borderRadius: 8, padding: "8px 14px", fontSize: 13, outline: "none", flex: 1, maxWidth: 280, color: "#333" },

    // Active project card
    projCard: { border: "1px solid #e8e8e8", borderRadius: 12, padding: "14px 18px", background: "#fff", marginBottom: 10, cursor: "default" },
    projCardTop: { display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12, marginBottom: 8 },
    projLogoWrap: { display: "flex", alignItems: "flex-start", gap: 12, flex: 1, minWidth: 0 },
    projLogo: { width: 38, height: 38, borderRadius: 8, objectFit: "cover", flexShrink: 0 },
    projLogoFallback: { width: 38, height: 38, borderRadius: 8, background: "#f0f0f0", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, color: "#888", flexShrink: 0 },
    projName: { fontSize: 13, fontWeight: 700, color: "#1a1a1a", cursor: "pointer", lineHeight: 1.3 },
    projMeta: { fontSize: 11, color: "#888", marginTop: 3 },
    projDivider: { borderTop: "1px solid #f0f0f0", margin: "10px 0 8px" },
    statsRow: { display: "flex", alignItems: "center", gap: 16, fontSize: 12, color: "#888", flexWrap: "wrap" },
    statItem: { display: "flex", gap: 4 },
    statStrong: { fontWeight: 700, color: "#1a1a1a" },
    rightBadges: { display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 5, flexShrink: 0 },

    // Badges / Pills
    badgeInTask:   { background: "#e6f0ff", color: "#1677ff", borderRadius: 999, padding: "2px 10px", fontSize: 11, fontWeight: 600, alignSelf: "flex-end" },
    badgeArchive:  { background: "#f0f0f0", color: "#666", borderRadius: 999, padding: "2px 8px", fontSize: 10, fontWeight: 600, display: "inline-block" },
    badgeIdInit:   { background: "#fff7e6", color: "#d46b08", borderRadius: 6, padding: "1px 8px", fontSize: 10, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 3 },
    badgeIdReq:    { background: "#fff7e6", color: "#e8a020", borderRadius: 6, padding: "1px 8px", fontSize: 10, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 3 },
    badgeIdAdded:  { background: "#e6f7ee", color: "#1a7a42", borderRadius: 6, padding: "1px 8px", fontSize: 10, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 3 },
    badgeIdExpiry: { background: "#fff0f0", color: "#c0392b", borderRadius: 6, padding: "1px 8px", fontSize: 10, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 3 },

    dotOn:   { color: "#1a7a42", fontWeight: 600, fontSize: 12, cursor: "pointer" },
    dotHold: { color: "#d46b08", fontWeight: 600, fontSize: 12, cursor: "pointer" },
    dotOff:  { color: "#c0392b", fontWeight: 600, fontSize: 12, cursor: "pointer" },

    // All projects
    categoryHeader: { fontSize: 11, fontWeight: 700, color: "#bbb", textTransform: "uppercase", letterSpacing: "0.6px", margin: "16px 0 8px" },
    allProjItem: { display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", padding: "9px 14px", border: "1px solid #f0f0f0", borderRadius: 8, marginBottom: 6, background: "#fff" },
    allProjLeft: { display: "flex", alignItems: "center", gap: 10, flex: 1, minWidth: 0 },
    allProjLogoSm: { width: 28, height: 28, borderRadius: 6, objectFit: "cover", flexShrink: 0 },
    allProjLogoFallback: { width: 28, height: 28, borderRadius: 6, background: "#f0f0f0", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, color: "#888", flexShrink: 0 },
    allProjName: { fontSize: 13, color: "#1a1a1a", fontWeight: 500 },
    allProjRight: { display: "flex", alignItems: "center", gap: 8, flexShrink: 0 },
    linkBtn: { color: "#1677ff", fontSize: 12, textDecoration: "underline", cursor: "pointer", background: "none", border: "none", padding: 0 },

    // Copy link row
    copyLinkRow: { display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 10, paddingTop: 8, borderTop: "1px solid #f0f0f0", flexWrap: "wrap", gap: 8 },
    radioGroup: { display: "flex", alignItems: "center", gap: 12, fontSize: 12, color: "#555" },
    copyLinkActions: { display: "flex", gap: 12 },
    copyLinkAction: { fontSize: 12, color: "#1677ff", textDecoration: "underline", cursor: "pointer" },

    // Back nav
    backRow: { display: "flex", alignItems: "center", gap: 10, marginBottom: 14, paddingBottom: 12, borderBottom: "1px solid #f0f0f0" },
    backBtn: { background: "none", border: "none", color: "#1677ff", fontSize: 13, cursor: "pointer", fontWeight: 600, padding: "4px 0", display: "flex", alignItems: "center", gap: 4 },

    emptyState: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 20px", color: "#aaa", fontSize: 13 },
};

class UserProjects extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 1,
            projects: [],
            availableJobs: [],
            selectedJob: null,
            isOpenPopover: false,
            isShowJobDetails: false,
            searchJobText: "",
            copyLinkHost: "PMW",
        };
    }

    componentDidMount() {
        this.fetchProjectDetails();
    }

    selectTab = (tab) => {
        if (tab === 1) this.fetchProjectDetails();
        else this.fetchAvailableJobs();
        this.setState({ selectedTab: tab });
    };

    fetchProjectDetails = async () => {
        store.dispatch(setLoader(true));
        try {
            let resp = await ApiEndpoints.UserProfile.fetchUserActiveProjects({ user_id: this.props.user_id, archive_status: [0, 1, 2] });
            let projects = resp.data.data.sort((a, b) => new Date(b.last_task_date) - new Date(a.last_task_date));
            this.setState({ projects });
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    };

    fetchAvailableJobs = async () => {
        try {
            let resp = await ApiEndpoints.UserProfile.userVisibleProject({ user_id: this.props.user_id });
            let availableJobs = groupArrayOnKey(resp.data.data || [], "job_category_id");
            this.setState({ availableJobs });
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
    };

    showTaskData = async (job) => {
        store.dispatch(setLoader(true));
        try {
            let resp = await ApiEndpoints.JobTask.fetch({ job_id: job.job_id });
            this.setState({ selectedJob: { ...job, taskList: resp.data.data } });
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    };

    downloadFileByID = async (fileId) => {
        store.dispatch(setLoader(true));
        try {
            let urlResp = await ApiEndpoints.Files.getFileID({ file_id: fileId });
            let fileUrl = urlResp.data.data[0] ? urlResp.data.data[0].url : null;
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = true;
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    };

    togglePopover = (job) => {
        this.setState({ isOpenPopover: this.state.isOpenPopover ? false : { ...job } });
    };

    onChangeArchiveStatus = (key, value) => {
        let { isOpenPopover } = this.state;
        isOpenPopover.application = isOpenPopover.application || {};
        isOpenPopover.application[key] = value;
        this.setState({ isOpenPopover });
    };

    archiveStatusSave = async (job) => {
        store.dispatch(setLoader(true));
        let { availableJobs } = this.state;
        try {
            if (job.application && job.application.application_id) {
                let body = { application_id: job.application.application_id, archive_status: job.application.archive_status };
                if (job.application.archive_message) body.archive_message = job.application.archive_message;
                await ApiEndpoints.Applicants.update(body);
            } else {
                let body = { job_id: job.job_id, user_id: this.props.user_id, job_location_id: job.JobLocations[0].job_location_id, archive_status: job.application.archive_status };
                if (job.application.archive_message) body.archive_message = job.application.archive_message;
                await ApiEndpoints.Applicants.insertApplication(body);
            }
            Object.keys(availableJobs).forEach(catId => {
                availableJobs[catId] = availableJobs[catId].map(obj => obj.job_id === job.job_id ? job : obj);
            });
            this.setState({ availableJobs, isOpenPopover: false });
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    };

    getJobShareLink = (job, linkType) => {
        let { copyLinkHost } = this.state;
        let baseUrl = copyLinkHost === "PMW" ? "https://link.pickmywork.com/" : "https://link.abbecho.com/";
        baseUrl += linkType === "CAPTURE" ? "fr/capture/" : (linkType === "CLICK" ? "fr/click/" : "fr/nclick/");
        let link = baseUrl + `${Buffer.from(String(job.job_id)).toString("base64")}/u/${Buffer.from(this.props.user_id).toString("base64")}`;
        copyCodeToClipboard(link);
        store.dispatch(setSuccess({ show: true, message: "Link Copied!" }));
    };

    renderIdStatusBadge(status) {
        if (status === 1) return <span style={PS.badgeIdInit}><Icon style={{ fontSize: 10 }}>warning</Icon>ID Initiated</span>;
        if (status === 2) return <span style={PS.badgeIdReq}><Icon style={{ fontSize: 10 }}>check_circle_outline</Icon>ID Requested</span>;
        if (status === 3) return <span style={PS.badgeIdAdded}><Icon style={{ fontSize: 10 }}>task_alt</Icon>ID Added</span>;
        if (status === 4) return <span style={PS.badgeIdExpiry}><Icon style={{ fontSize: 10 }}>warning</Icon>ID Expired</span>;
        return null;
    }

    renderArchiveDot(archiveStatus, tooltip) {
        if (archiveStatus === 1) return <span style={PS.dotHold} title={tooltip}>● Hold</span>;
        if (archiveStatus === 2) return <span style={PS.dotOff} title={tooltip}>● Off</span>;
        return null;
    }

    renderProjectLogo(logoKey, name, size = 38, radius = 8) {
        if (logoKey) return <img src={logoKey} style={{ width: size, height: size, borderRadius: radius, objectFit: "cover", flexShrink: 0 }} alt="" />;
        const initials = (name || "?").charAt(0).toUpperCase();
        const fallback = { ...PS.projLogoFallback, width: size, height: size, borderRadius: radius };
        return <div style={fallback}>{initials}</div>;
    }

    renderActiveProjects(projects) {
        const { selectedJob } = this.state;

        if (selectedJob) {
            return (
                <div>
                    <div style={PS.backRow}>
                        <button style={PS.backBtn} onClick={() => this.setState({ selectedJob: null })}>
                            ← Back
                        </button>
                        <span
                            style={{ fontSize: 14, fontWeight: 700, color: "#1a1a1a", cursor: "pointer" }}
                            onClick={() => this.setState({ isShowJobDetails: selectedJob })}
                        >
                            {selectedJob.employer_name} — {selectedJob.job_title}
                        </span>
                    </div>
                    <PartnerMapDetail user={{ user_id: this.props.user_id }} selectedJob={selectedJob} taskList={selectedJob.taskList} />
                </div>
            );
        }

        if (!projects.length) {
            return <div style={PS.emptyState}><span style={{ fontSize: 32, marginBottom: 10 }}>📂</span>No active projects found.</div>;
        }

        return projects.map((job, i) => {
            const pending  = (job.statusCount || {})['0'] || 0;
            const verified = (job.statusCount || {})['1'] || 0;
            const rejected = (job.statusCount || {})['2'] || 0;
            const fmtDate  = (d) => d ? moment(d).utcOffset("+05:30").format("Do MMM'YY HH:mm") : null;

            return (
                <div key={i} style={PS.projCard}>
                    <div style={PS.projCardTop}>
                        <div style={PS.projLogoWrap}>
                            <div onClick={() => this.setState({ isShowJobDetails: job })} style={{ cursor: "pointer" }}>
                                {this.renderProjectLogo(job.logo_key, job.employer_name)}
                            </div>
                            <div style={{ minWidth: 0 }}>
                                <div style={PS.projName} onClick={() => this.setState({ isShowJobDetails: job })}>
                                    {job.employer_name} — {job.job_title}
                                </div>
                                <div style={PS.projMeta}>
                                    {fmtDate(job.first_task_date) && <>First Task: {fmtDate(job.first_task_date)}</>}
                                    {fmtDate(job.first_task_date) && fmtDate(job.last_task_date) && <span style={{ margin: "0 6px", color: "#ddd" }}>|</span>}
                                    {fmtDate(job.last_task_date) && <>Last Task: {fmtDate(job.last_task_date)}</>}
                                </div>
                                {job.extra_details_status > 0 && (
                                    <div style={{ marginTop: 5 }}>{this.renderIdStatusBadge(job.extra_details_status)}</div>
                                )}
                            </div>
                        </div>
                        
                        <div style={PS.rightBadges}>
                            <div style={{ ...PS.statItem, alignItems: "baseline", gap: 5 }}>
                                <span
                                    style={{ fontSize: 18, fontWeight: 800, color: "#1677ff", cursor: "pointer", lineHeight: 1 }}
                                    onClick={() => this.showTaskData(job)}
                                    title="View task map"
                                >
                                    {job.exact_task_done}
                                </span>
                                <span style={{ fontSize: 11, color: "#888" }}>All Tasks</span>
                            </div>
                           
                        </div>
                    </div>

                    <div style={PS.projDivider} />
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                        <div style={PS.statsRow}>
                            <div style={PS.statItem}>Pending: <strong style={PS.statStrong}>{pending}</strong></div>
                            <div style={PS.statItem}>Rejected: <strong style={PS.statStrong}>{rejected}</strong></div>
                            <div style={PS.statItem}>Verified: <strong style={PS.statStrong}>{verified}</strong></div>                            
                        </div>
                        <div>
                            {job.status != null && CONSTANTS.APPLICATION_STATUS_TEXT[job.status] && (
                                <span style={PS.badgeInTask}>{CONSTANTS.APPLICATION_STATUS_TEXT[job.status]}</span>
                            )}
                            {job.job_archive_status !== 0 && (
                                <span style={PS.badgeArchive}>{CONSTANTS.ARCHIVE_STATUS_TEXT[job.job_archive_status]}</span>
                            )}
                            {this.renderArchiveDot(job.application_archive_status, job.application_archive_message)}
                        </div>
                    </div>
                </div>
            );
        });
    }

    renderAllProjects(filteredAvailableJobs) {
        let user = store.getState().user;
        const isAdmin = !!user.UserRole.filter(r => r.role_id === 1).length;
        const isAllowedCopyLink = isAdmin || ["mENdTdgHly"].indexOf(user.user_id) !== -1;
        const { isOpenCopyLink, copyLinkHost } = this.state;

        return Object.keys(filteredAvailableJobs).map((catId, ci) => {
            const jobs = filteredAvailableJobs[catId];
            if (!jobs.length) return null;
            const catName = jobs[0].JobCategory ? jobs[0].JobCategory.title : "Other";

            return (
                <div key={ci}>
                    <div style={PS.categoryHeader}>{catName}</div>
                    {jobs.map((job, i) => {
                        const appStatus = job.application ? job.application.archive_status : 0;
                        const popoverId = `user_project_${job.job_id}`;

                        return (
                            <div key={i} style={PS.allProjItem}>
                                <div style={PS.allProjLeft}>
                                    <div onClick={() => this.setState({ isShowJobDetails: job })} style={{ cursor: "pointer" }}>
                                        {this.renderProjectLogo(job.Employer.logo_key, job.Employer.employer_name, 28, 6)}
                                    </div>
                                    <div>
                                        <div
                                            style={{ ...PS.allProjName, cursor: "pointer" }}
                                            onClick={() => this.setState({ isShowJobDetails: job })}
                                        >
                                            {job.Employer.employer_name} — {job.title}
                                        </div>
                                        {job.archive_status !== 0 && (
                                            <span style={{ ...PS.badgeArchive, marginTop: 3, display: "inline-block" }}>
                                                {CONSTANTS.ARCHIVE_STATUS_TEXT[job.archive_status]}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div style={PS.allProjRight}>
                                    {job.action_status > 10 && isAllowedCopyLink && !job.archive_status && (
                                        <button style={PS.linkBtn} onClick={() => this.setState({ isOpenCopyLink: isOpenCopyLink === job.job_id ? null : job.job_id })}>
                                            🔗 Link
                                        </button>
                                    )}

                                    <div id={popoverId} title={job.application && job.application.archive_message} onClick={() => this.togglePopover(job)}>
                                        {(!job.application || !appStatus)     && <span style={PS.dotOn}>● On</span>}
                                        {appStatus === 1 && <span style={PS.dotHold}>● Hold</span>}
                                        {appStatus === 2 && <span style={PS.dotOff}>● Off</span>}
                                    </div>

                                    {this.state.isOpenPopover.job_id === job.job_id && (
                                        <Popover target={popoverId} placement="bottom" isOpen toggle={() => this.setState({ isOpenPopover: false })}>
                                            <PopoverHeader style={{ fontSize: 13 }}>
                                                Update Status
                                                <Icon className="float-right" style={{ cursor: "pointer", fontSize: 16 }} onClick={() => this.setState({ isOpenPopover: false })}>close</Icon>
                                            </PopoverHeader>
                                            <PopoverBody>
                                                <div style={{ display: "flex", gap: 0, border: "1px solid #e0e0e0", borderRadius: 8, overflow: "hidden", marginBottom: 10 }}>
                                                    {Object.keys(CONSTANTS.ARCHIVE_STATUS).map((key, ki) => {
                                                        const val = CONSTANTS.ARCHIVE_STATUS[key];
                                                        const curVal = this.state.isOpenPopover.application && this.state.isOpenPopover.application.archive_status;
                                                        const isActive = curVal === val;
                                                        const activeColor = key === "ON" ? "#27ae60" : key === "HOLD" ? "#d46b08" : "#c0392b";
                                                        return (
                                                            <button
                                                                key={ki}
                                                                onClick={() => this.onChangeArchiveStatus("archive_status", val)}
                                                                style={{ flex: 1, padding: "6px 0", border: "none", fontSize: 12, fontWeight: 600, cursor: "pointer", borderRight: ki < 2 ? "1px solid #e0e0e0" : "none", background: isActive ? activeColor + "22" : "#fff", color: isActive ? activeColor : "#555" }}
                                                            >
                                                                {key}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                                {this.state.isOpenPopover.application && this.state.isOpenPopover.application.archive_status === 1 && (
                                                    <InputFeild style={{ fontSize: 12, marginBottom: 8 }} placeholder="Hold reason (optional)" value={this.state.isOpenPopover.application.archive_message || ""} onChange={(e) => this.onChangeArchiveStatus("archive_message", e.target.value)} />
                                                )}
                                                <Button size="sm" block color="danger" onClick={() => this.archiveStatusSave(this.state.isOpenPopover)}>Save</Button>
                                            </PopoverBody>
                                        </Popover>
                                    )}
                                </div>

                                {isOpenCopyLink === job.job_id && (
                                    <div style={{ width: "100%", ...PS.copyLinkRow }}>
                                        <div style={PS.radioGroup}>
                                            <label style={{ cursor: "pointer" }}>
                                                <input type="radio" style={{ marginRight: 4 }} checked={copyLinkHost === "PMW"} onChange={() => this.setState({ copyLinkHost: "PMW" })} />
                                                PickMyWork
                                            </label>
                                            <label style={{ cursor: "pointer" }}>
                                                <input type="radio" style={{ marginRight: 4 }} checked={copyLinkHost === "ABBECHO"} onChange={() => this.setState({ copyLinkHost: "ABBECHO" })} />
                                                AbBecho
                                            </label>
                                        </div>
                                        <div style={PS.copyLinkActions}>
                                            <span style={PS.copyLinkAction} onClick={() => this.getJobShareLink(job, "CAPTURE")}>Capture Link</span>
                                            <span style={PS.copyLinkAction} onClick={() => this.getJobShareLink(job, "CLICK")}>Click Link</span>
                                            <span style={PS.copyLinkAction} onClick={() => this.getJobShareLink(job, "UNIQUE_LEAD")}>Unique Link</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            );
        });
    }

    render() {
        let { selectedTab, projects, availableJobs, isShowJobDetails, searchJobText } = this.state;

        let filteredProjects = projects;
        let filteredAvailableJobs = { ...availableJobs };

        if (searchJobText) {
            const q = searchJobText.toLowerCase();
            if (selectedTab === 1) {
                filteredProjects = projects.filter(j => `${j.employer_name} - ${j.job_title}`.toLowerCase().includes(q));
            } else {
                Object.keys(availableJobs).forEach(catId => {
                    filteredAvailableJobs[catId] = availableJobs[catId].filter(j =>
                        `${j.Employer.employer_name} - ${j.title}`.toLowerCase().includes(q)
                    );
                });
            }
        }

        return (
            <>
                <div style={PS.container}>
                    {/* Top bar: switcher + search */}
                    <div style={PS.topBar}>
                        <div style={PS.switcher}>
                            <button
                                style={{ ...PS.switchBtn, ...(selectedTab === 1 ? PS.switchBtnActive : {}) }}
                                onClick={() => this.selectTab(1)}
                            >
                                Active Projects
                            </button>
                            <button
                                style={{ ...PS.switchBtnLast, ...(selectedTab === 2 ? PS.switchBtnActive : {}) }}
                                onClick={() => this.selectTab(2)}
                            >
                                All Projects
                            </button>
                        </div>
                        <input
                            style={PS.searchInput}
                            placeholder="🔍 Search projects..."
                            value={searchJobText}
                            onChange={(e) => this.setState({ searchJobText: e.target.value })}
                        />
                    </div>

                    {/* Content */}
                    {selectedTab === 1
                        ? this.renderActiveProjects(filteredProjects)
                        : this.renderAllProjects(filteredAvailableJobs)
                    }
                </div>

                {/* Job Info Modal */}
                <Modal centered size="lg" isOpen={!!isShowJobDetails} toggle={() => this.setState({ isShowJobDetails: null })}>
                    <ModalBody>
                        {!!isShowJobDetails && <JobInformation job={isShowJobDetails} isOnlyView />}
                    </ModalBody>
                </Modal>
            </>
        );
    }
}

export default UserProjects;
